import { useEffect, useMemo } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

const isValidPageParam = (pageValue: string | null): boolean => {
  if (!pageValue) return true;

  if (!/^[1-9]\d*$/.test(pageValue)) {
    return false;
  }

  const num = parseInt(pageValue, 10);
  return !isNaN(num) && num > 0 && num <= Number.MAX_SAFE_INTEGER;
};
export const useIsPageParamValid = (): boolean => {
  const [searchParams] = useSearchParams();
  const pageValue = searchParams.get("page");

  return useMemo(() => isValidPageParam(pageValue), [pageValue]);
};

export const useSanitizedPageParam = (): void => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const pageValue = params.get("page");

    if (!pageValue || isValidPageParam(pageValue)) return;

    params.delete("page");

    const newSearch = params.toString();
    const newUrl = newSearch ? `${location.pathname}?${newSearch}` : location.pathname;

    if (newUrl === `${location.pathname}${location.search}`) return;

    navigate(newUrl, { replace: true });
  }, [location.pathname, location.search, navigate]);
};
